import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'tr[app-tr-order]',
  template: `
    <td class="align-middle">
      <a  routerLink="{{order.id}}" ># {{order.folio}}</a>
      <span *ngIf="order.status"># {{order.folio}}</span>
    </td>
    <td class="align-middle">{{order?.tanque?.name}}</td>
    <td class="align-middle text-center">{{ order.liters }} Lts.</td>
    <td class="align-middle text-center">
      <span *ngIf="order.price">{{ order.price | currency}}</span>
      <span *ngIf="!order.price">-</span>
    </td>
    <td class="align-middle">{{order?.settlement?.name}}</td>
    <td class="align-middle text-center">
      <div class="badge badge-sm rounded-pill" [ngClass]="order?.status ? 'bg-success' : 'bg-warning'">
        <span *ngIf="!order?.status">Pendiente</span>
        <span *ngIf="order?.status">Entregado</span>
      </div>
    </td>
    <td class="align-middle text-center">{{order.created_at | date: 'dd/MM/yy'}}</td>
    <td class="align-middle text-center">{{ order.updated_at | date: 'dd/MM/yy HH:mm' }}</td>
    <td class="align-middle">
      <button class="btn btn-link"  (click)="deleteOrder(order)">
        <fa-icon [icon]="icons.faTrashAlt" size="1x" class="center-icon text-danger"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrOrderComponent {
  @Input() order: any = {};
  @Input() profile: any;
  @Input() permissions: any;
  @Output() refreshOrders = new EventEmitter();

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  ngOnInit(): void {
    /*this.store.getSettlement(this.order.settlement_id).subscribe({
      next: (data: any) => {
        console.log("settlement: ", data);
        this.order.settlement = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    });
    this.store.getTanque(this.order.tanque_id).subscribe({
      next: (data: any) => {
        this.order.tanque = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    });*/
  }

  deleteOrder(order: any) {
    this.store.destroyPurchaseOrder(order.id).subscribe({
      next: (data: any) => {        
        this.refreshOrders.emit();
        this.toastr.success('Pedido eliminado correctamente.', 'Exito');
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(err.error.message, 'Error');
      }
    });
  }
}
